import React, { useEffect, useState } from 'react';
import OLTileLayer from 'ol/layer/Tile';
import OLVectorLayer from 'ol/layer/Vector';
import OLTileSource from 'ol/source/Tile';
import OLVectorSource from 'ol/source/Vector';
import OLClusterSource from 'ol/source/Cluster';
import * as mapStyles from './MapVectorStyles.js';
import { addPropsToChildren } from '../controller/addPropsToChildren.js';

const fn = () => {};

const Layers = (props) => {
    const { map, children, onLoadStatus = () => {} } = props;
    const [mappedChildren, setMappedChildren] = useState([]);

    //ΔVΔVΔ: Assign z-index by order in child array, can be overriden in each child obj props
    // const mappedChildren

    // console.log(props)
    useEffect(() => {
        if (!map) return;
        const mappedKids = addPropsToChildren(children, {
            map,
            propsFilter: (index, child, props) => {
                props.zIndex = child.props.zIndex || index;
                props.id = `layer_${index}_${child.props.id || child.props.type || child.type.name || ''}`;
                props.onLoadStatus = (status) => onLoadStatus(props.id, status);
                return props;
            }
        });
        setMappedChildren(mappedKids);
    }, [map, children]);

    return <div>{mappedChildren}</div>;
};
export default Layers;

const Layer = (props) => {
    const [addedToMap, setAddedToMap] = useState(false);
    const { map, opacity = 1, visible = true, zIndex = 0, title } = props;
    const { constructor = null, onAdded = fn, onPreRender = fn, onPostRender = fn } = props;
    const [lyr] = useState(constructor);
    // console.log(title + 'lyr');

    const setOpacity = () => {
        if (!map || !lyr) return;
        let failsafeOpacity = opacity == null || isNaN(opacity) ? 1 : opacity; //If opacity is set with a non number throws assertion error
        lyr.setOpacity(visible ? failsafeOpacity : 0);
    };

    useEffect(() => map && lyr && setOpacity(), [visible, opacity]);
    useEffect(() => map && lyr && lyr.setZIndex(zIndex), [zIndex]);
    useEffect(() => map && lyr && lyr.set('title', title));

    const preRender = (e) => {
        console.log(title + '&&& Prerender');
        onPreRender(e);
    };

    const postRender = (e) => {
        console.log(title + '%%% Postrender');
        onPostRender(e);
    };

    useEffect(() => {
        if (!map || !lyr) return;
        if (addedToMap) return; //ΔVΔVΔ: Only Happens On local and testing, prevents re-adding

        // lyr.on('prerender', preRender);
        // lyr.on('postrender', postRender);
        map.addLayer(lyr);
        lyr.setZIndex(zIndex);
        setAddedToMap(true);
        setOpacity();
        onAdded(lyr);

        return () => {
            if (map) {
                map.removeLayer(lyr);
                setAddedToMap(false);
            }
        };
    }, [map, lyr]);
    return null;
};
export { Layer };

const TileLayer = (props) => {
    const { map, opacity = 1, visible = true, source, url, zIndex = 0, style, title, className } = props;
    const { onAdded = fn, onPreRender = fn, onPostRender = fn } = props;
    let src = url || source || new OLTileSource();

    const [lyr] = useState(
        new OLTileLayer({
            source: src,
            zIndex,
            title,
            style,
            className,
            map
        })
    );

    return <Layer zIndex={zIndex} opacity={opacity} visible={visible} onAdded={onAdded} onPreRender={onPreRender} onPostRender={onPostRender} map={map} constructor={lyr} />;
};

export { TileLayer };

const VectorLayer = (props) => {
    const { map, features, opacity = 1, visible = true, zIndex = 0, title = 'vector layer', style = mapStyles.outlineExtent, className } = props;
    const { onAdded = fn, onPreRender = fn, onPostRender = fn, renderOrder = () => 1 } = props;

    const [lyr] = useState(
        new OLVectorLayer({
            title,
            opacity: visible ? opacity : 0,
            source: new OLVectorSource(),
            style,
            zIndex,
            className,
            renderOrder
        })
    );

    const updateFeatures = () => {
        const lyrSource = new OLVectorSource({
            features,
            overlaps: false
        });
        lyr.setSource(lyrSource);
    };
    const clearFeatures = () => {
        lyr.setSource(new OLVectorSource());
    };
    useEffect(() => map && features && updateFeatures(), [features]);
    useEffect(() => map && !features && clearFeatures(), [features]);

    return (
        <Layer
            title={title}
            zIndex={zIndex}
            opacity={opacity}
            visible={visible}
            onAdded={() => {
                lyr.setStyle(style);
                updateFeatures();
                onAdded(lyr);
            }}
            map={map}
            onPreRender={onPreRender}
            onPostRender={onPostRender}
            constructor={lyr}
        />
    );
};
export { VectorLayer };

const VectorLayer2 = (props) => {
    const { map, features, opacity = 1, visible = true, zIndex = 0, title = 'vector layer', style = mapStyles.outlineExtent, className, loader } = props;
    const { onAdded = fn, onPreRender = fn, onPostRender = fn, renderOrder = () => 1 } = props;
    const [lyrSource] = useState(
        new OLVectorSource({
            overlaps: false,
            loader: loader,
            features: features
        })
    );

    const [lyr] = useState(
        new OLVectorLayer({
            title,
            opacity: visible ? opacity : 0,
            source: lyrSource,
            style,
            zIndex,
            className,
            renderOrder
        })
    );

    const updateFeatures = (newFeatures) => {
        lyrSource.clear();
        lyrSource.addFeatures(newFeatures);
    };
    useEffect(() => {
        if (!map) return;
        if (!features) return;
        updateFeatures(features);
    }, [features]);

    return (
        <Layer
            title={title}
            zIndex={zIndex}
            opacity={opacity}
            visible={visible}
            onAdded={() => {
                lyr.setStyle(style);
                onAdded(lyr);
            }}
            map={map}
            onPreRender={onPreRender}
            onPostRender={onPostRender}
            constructor={lyr}
        />
    );
};
export { VectorLayer2 };

const ClusterLayer = (props) => {
    const { map, features, opacity = 1, visible = true, zIndex = 0, title = 'vector layer', style = mapStyles.outlineExtent, className, source = null } = props;
    const { onAdded = fn, onPreRender = fn, onPostRender = fn } = props;

    const [lyr] = useState(
        new OLVectorLayer({
            title,
            opacity: visible ? opacity : 0,
            source: new OLVectorSource(),
            style,
            zIndex,
            className
        })
    );

    const updateFeatures = () => {
        const lyrSource = new OLVectorSource({
            features,
            overlaps: false
        });

        const clusterSource = new OLClusterSource({
            distance: 40,
            minDistance: 20,
            source: lyrSource
        });
        lyr.setSource(clusterSource);
    };
    useEffect(() => map && features && updateFeatures(), [features]);

    return (
        <Layer
            title={title}
            zIndex={zIndex}
            opacity={opacity}
            visible={visible}
            onAdded={() => {
                lyr.setStyle(style);
                updateFeatures();
                onAdded(lyr);
            }}
            map={map}
            onPreRender={onPreRender}
            onPostRender={onPostRender}
            constructor={lyr}
        />
    );
};
export { ClusterLayer };
